<template>
    <div :id="id" :class="className" :style="{height: height, width: width}" />
</template>

<script>
    import resize from "../../components/accidentManagement/mixins/resize";
    const echarts = require("echarts");

    export default {
        mixins: [resize],
        props: {
            className: {
                type: String,
                default: "chart",
            },
            id: {
                type: String,
                default: "bar-chart",
            },
            width: {
                type: String,
                default: '100%',
            },
            height: {
                type: String,
                default: "100%",
            },
            barData: {
                type: Array,
            }
        },
        data() {
            return {
                chart: null,
            };
        },
        mounted() {
            this.initChart();
        },
        beforeDestroy() {
            if (!this.chart) {
                return;
            }
            this.chart.dispose();
            this.chart = null;
        },
        computed: {
            label: function () {
                return this.barData.map(item => item.name)
            }
        },
        methods: {
            initChart() {
                this.chart = echarts.init(document.getElementById(this.id));

                this.chart.setOption({
                    xAxis: {
                        type: 'category',
                        data: this.label,
                        axisLabel: {
                            color: '#999999',
                            textStyle: {
                                fontSize: 14,
                                fontWeight: 400,
                                color: '#999999'
                            },
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: true,
                            color: '#999999'
                        }
                    },
                    yAxis: {
                        type: 'value',
                        name: '(kWh)',
                        nameTextStyle: {
                            fontSize: 14,
                            color: '#999999',
                            fontWeight: 400,
                            bottom: 40,
                        },
                        axisLine: {
                            show: true,
                            color: '#999999',
                        },
                        axisLabel: {
                            color: '#999999',
                            textStyle: {
                                fontSize: 14,
                                fontWeight: 400,
                                color: '#999999'
                            },
                            // formatter: function (value, index) {
                            //     if (value >= 10000) {
                            //         return value / 1000 + 'k';
                            //     }
                            //     return value;
                            // }
                        }
                    },
                    series: [{
                        data: this.barData,
                        type: 'bar',
                    }]
                });
            },
            refresh() {
                if (!this.chart) {
                    console.error('chart is null');
                    return;
                }
                this.chart.setOption({
                    xAxis: {
                        data: this.label
                    },
                    series: [{
                        data: this.barData,
                        type: 'bar',
                    }]
                })
            }
        },
        watch: {
            barData: function (newData, oldData) {
                this.refresh()
            }
        }
    };
</script>

<style lang="less" scoped>
    body {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        background: chartreuse;
    }
</style>